import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Navigate } from "react-router-dom";
import React from "react";
import { AuthPageLayout } from "../pages/Auth/Layout";
import { GuestPageLayout } from "../pages/Guest/Layout";
const LoginPage = React.lazy(() => import("../pages/Auth/LoginPage"));
const SignUpPage = React.lazy(() => import("../pages/Auth/SignUpPage"));
const FormPage = React.lazy(() => import("../pages/Guest/Form"));
const FormResponsePage = React.lazy(() => import("../pages/Guest/Form/Response"));
export const publicRoutes = [
    {
        path: "/guest",
        element: _jsx(GuestPageLayout, {}),
        children: [
            {
                path: "form/:formId",
                element: _jsx(FormPage, {}),
            },
            {
                path: "form/:formId/response",
                element: _jsx(FormResponsePage, {}),
            },
        ],
    },
    {
        path: "/",
        element: _jsx(AuthPageLayout, {}),
        children: [
            {
                path: "/login",
                element: _jsx(LoginPage, {}),
            },
            {
                path: "/signup",
                element: _jsx(SignUpPage, {}),
            },
            {
                path: "*",
                element: _jsx(Navigate, { to: "/" }),
            },
        ],
    },
];
